import React, { useState, useEffect } from 'react';
import { api } from '../api';
import './DashboardPages.css';

const TRIP_STATUS_LABELS = {
  pending: 'Pending',
  in_transit: 'In Transit',
  delivered: 'Delivered',
};

function TripsPage() {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const { trips: data } = await api.getTrips(filter || undefined);
        if (!cancelled) setTrips(data);
      } catch (err) {
        if (!cancelled) setError(err.message);
        if (!cancelled) setTrips([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [filter]);

  const formatDateTime = (d) => {
    if (!d) return '—';
    const dt = new Date(d);
    return dt.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="dashboard-page">
      <h1>Trip Management</h1>
      <p className="dashboard-subtitle">Monitor active trips and view trip history</p>

      <div className="orders-toolbar">
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="orders-filter"
        >
          <option value="">All trips</option>
          <option value="pending">Pending</option>
          <option value="in_transit">In Transit</option>
          <option value="delivered">Delivered</option>
        </select>
      </div>

      {error && (
        <div className="orders-error">
          {error}
        </div>
      )}

      {loading ? (
        <div className="orders-placeholder">
          <p>Loading trips…</p>
        </div>
      ) : trips.length === 0 ? (
        <div className="orders-placeholder">
          <p>No trips yet. Assign drivers to orders to create trips.</p>
          <p className="orders-hint">Trip data: driver, pickup time, delivery time, distance</p>
        </div>
      ) : (
        <div className="orders-list">
          {trips.map((t) => (
            <div key={t.trip_id} className="order-card">
              <div className="order-card-header">
                <span className="order-id">Trip #{t.trip_id}</span>
                <span className={`order-status status-${t.trip_status}`}>
                  {TRIP_STATUS_LABELS[t.trip_status] || t.trip_status}
                </span>
              </div>
              <div className="order-card-body">
                <p><strong>Driver:</strong> {t.driver_name || '—'} {t.driver_phone && `(${t.driver_phone})`}</p>
                <p><strong>Pickup:</strong> {t.pickup_location}</p>
                <p><strong>Delivery:</strong> {t.delivery_location}</p>
                <p><strong>Produce:</strong> {t.produce_type || '—'}</p>
                <p><strong>Pickup time:</strong> {formatDateTime(t.pickup_time)}</p>
                <p><strong>Delivery time:</strong> {formatDateTime(t.delivery_time)}</p>
                <p><strong>Distance:</strong> {t.distance_km != null ? `${t.distance_km} km` : '—'}</p>
                <p><strong>Order:</strong> #{t.order_id} — Farmer: {t.farmer_name || '—'}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TripsPage;
